<template> 
  <publish-form :is-edit='false'></publish-form>
</template>
<script>
  import PublishForm from './publishForm'
  export default {
    name: 'publishAdd',
    components: { PublishForm }
  }
</script>
<style>
</style>


